import React from 'react'

interface PieChartLabelProps {
    nome: string
    percent: number
    x: number
    y: number
    fontSize: number | undefined
}

const truncateText = (text: string, maxLength: number) => {
    if (text.length <= maxLength) return text

    if ('Segmenter' in Intl) {
        const segmenter = new Intl.Segmenter('pt', { granularity: 'word' })
        const words = Array.from(segmenter.segment(text)).map(
            seg => seg.segment
        )
        let truncated = ''

        for (const word of words) {
            if ((truncated + word).length > maxLength) break
            truncated += word + ' '
        }

        return truncated.trim() + '...'
    }

    return text.substring(0, maxLength) + '...'
}

const PieChartLabel: React.FC<PieChartLabelProps> = ({
    nome,
    percent,
    x,
    y,
    fontSize
}) => {
    return (
        <text
            x={x}
            y={y}
            textAnchor="middle"
            dominantBaseline="middle"
            fontSize={`clamp(10px, 1.1vw, ${fontSize || 14}px)`}
            fill="#000"
            fontWeight={600}
            stroke="white"
            strokeWidth={3}
            paintOrder="stroke"
        >
            <tspan x={x} dy="-10">
                {truncateText(nome, 12)}
            </tspan>
            <tspan
                x={x}
                dy="15"
                fontSize="clamp(10px, 1vw, 13px)"
                fontWeight={500}
            >
                {`${(percent * 100).toFixed(1)}%`}
            </tspan>
        </text>
    )
}

export default PieChartLabel
